import '../../scss/ExamDetail.scss'
import { useEffect, useState, useRef } from 'react';
import { IoMdMenu, IoIosInformationCircleOutline, IoMdExit } from "react-icons/io";
import { MdSettingsAccessibility } from "react-icons/md";
import { FaArrowRight } from "react-icons/fa";
import Navmenudetail from './Navmenudetail';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { dangbaiService } from 'services/dangbaiService';
import { ProgressSpinner } from 'primereact/progressspinner';
import NavInfo from './NavInfo';
import { dethitructuyenService } from 'services/dethitructuyenService';
import { useNavigate } from 'react-router-dom';
import { ThiTrucTuyenService } from 'services/ThiTrucTuyenService';

const ExamDetail = () => {
    var typ = localStorage.getItem('typeExam');
    var userId = localStorage.getItem('User_Id');
    const username = localStorage.getItem('fullname');
    const IdDeThi = localStorage.getItem('IdDeThi');

    if (IdDeThi == null || IdDeThi == "" || userId == null || username == "" || username == null) {
        window.location.href = '/'
    }
    const navigate = useNavigate();

    const [type, setType] = useState(typ || "");
    const [visible, setVisible] = useState(false);
    const [socauhoi, setSoCauHoi] = useState(1);
    const [dataDetail, setDataDetail] = useState([]);
    const [loading, setLoading] = useState(false);
    const [visibleInFo, setVisibleInFo] = useState(false);
    const [showForceFullscreen, setShowForceFullscreen] = useState(false);

    const openDetailMenu = () => {
        setVisible(true);
    }

    const onCloseDetailMenu = () => {
        setVisible(false);
    }

    const toast = useRef(null);

    const accept = () => {
        toast.current.show({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
    }

    const reject = () => {
        // toast.current.show({ severity: 'warn', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
    }

    const confirmExit = () => {
        confirmDialog({
            message: 'Are you sure you want to proceed?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            defaultFocus: 'accept',
            accept,
            reject
        });
    };

    const renderTitle = (type) => {
        if (type == "NGUPHAP") {
            return "Grammar and Vocabulary";
        }
        else if (type == "NGHE") {
            return "Listening";
        }
        else if (type == "DOC") {
            return "Reading";
        }
        else if (type == "VIET") {
            return "Writing";
        }
        else {
            return "Speaking";
        }
    }


    const loadData = async () => {
        setLoading(true);
        var typeExam = localStorage.getItem('typeExam');

        var body = {
            code: typeExam,
            kyThiId: localStorage.getItem('CaThiId') || localStorage.getItem('KyThiId') || null
        }
        let result = await dangbaiService.getdetail(body);
        if (result.data) {
            setType(result.data.data.ma);
            setSoCauHoi(result.data.data.socauhoi);
            setDataDetail(result.data.data)
        }
        setLoading(false);

    }

    useEffect(() => {
        // Kiểm tra xem thí sinh đã thi hay chưa
        const checkExamCompleted = async () => {
            try {
                const caThiId = localStorage.getItem('CaThiId');
                const dethiId = localStorage.getItem('IdDeThi');

                // Luôn cần dethiId để gọi API
                if (!dethiId || !userId) {
                    console.warn('Missing dethiId or userId, skipping exam completion check');
                    return;
                }

                // Nếu có caThiId, kiểm tra theo ca thi (nhưng vẫn cần gửi dethiId)
                if (caThiId && userId) {
                    const resumeRes = await ThiTrucTuyenService.checkResumeAttempt({
                        user_id: userId,
                        ca_thi_id: caThiId,
                        dethitructuyen_id: dethiId // Vẫn cần gửi để backend validate
                    });

                    if (resumeRes?.data?.is_fully_completed === true) {
                        toast.current.show({
                            severity: 'warn',
                            summary: 'Thông báo',
                            detail: 'Bạn đã hoàn thành bài thi này rồi. Không thể thi lại.',
                            life: 3000
                        });
                        // Quay lại màn checkDevice sau 2 giây
                        setTimeout(() => {
                            navigate('/checkDevice', { replace: true });
                        }, 2000);
                        return;
                    }
                } else if (dethiId && userId) {
                    // Kiểm tra theo đề thi
                    const resumeRes = await ThiTrucTuyenService.checkResumeAttempt({
                        user_id: userId,
                        dethitructuyen_id: dethiId
                    });

                    if (resumeRes?.data?.is_fully_completed === true) {
                        toast.current.show({
                            severity: 'warn',
                            summary: 'Thông báo',
                            detail: 'Bạn đã hoàn thành bài thi này rồi. Không thể thi lại.',
                            life: 3000
                        });
                        // Quay lại màn checkDevice sau 2 giây
                        setTimeout(() => {
                            navigate('/checkDevice', { replace: true });
                        }, 2000);
                        return;
                    }
                }
            } catch (error) {
                console.error('Error checking exam completion:', error);
                // Nếu có lỗi, vẫn cho phép vào (không chặn)
            }
        };

        checkExamCompleted();
        loadData();
    }, []);

    const requestFullScreen = async () => {
        try {
            const el = document.documentElement;
            if (document.fullscreenElement) {
                setShowForceFullscreen(false);
                return true;
            }
            if (el?.requestFullscreen) {
                await el.requestFullscreen();
                setShowForceFullscreen(false);
                return true;
            }
        } catch (e) {
            console.error('requestFullscreen error', e);
        }
        return false;
    };

    // Tự động bật fullscreen khi vào màn ExamDetail
    useEffect(() => {
        // Đánh dấu đang trong màn thi để tự động bật lại fullscreen sau khi reload
        sessionStorage.setItem('exam_fullscreen_required', 'true');

        // Kiểm tra fullscreen ngay khi vào màn (bao gồm cả sau khi reload)
        const checkFullscreen = async () => {
            if (!document.fullscreenElement) {
                // Thử gọi fullscreen ngay (có thể vẫn còn trong gesture chain từ click trước đó)
                const success = await requestFullScreen();
                if (!success) {
                    // Nếu không được, hiển thị modal yêu cầu click
                    setShowForceFullscreen(true);
                }
            }
        };

        // Gọi ngay lập tức (không delay) để tận dụng user gesture chain từ click button
        checkFullscreen();

        const onFsChange = async () => {
            if (document.fullscreenElement) {
                setShowForceFullscreen(false);
            } else {
                // Tự động bật lại fullscreen ngay khi user cố tắt
                // Thử gọi lại ngay lập tức (có thể bị chặn nếu không có user gesture)
                const success = await requestFullScreen();
                if (!success) {
                    // Nếu không được, hiển thị modal yêu cầu user click
                    setShowForceFullscreen(true);
                }
            }
        };
        document.addEventListener('fullscreenchange', onFsChange);

        return () => {
            document.removeEventListener('fullscreenchange', onFsChange);
        };
    }, []);

    const openStart = async () => {
        // Gọi fullscreen trước khi navigate (đang trong user gesture từ click button)
        await requestFullScreen();

        // Dùng navigate thay vì window.location.href để giữ fullscreen tốt hơn
        if (type && type === "NOI") {
            navigate('/startexamnoi');
        }
        else if (type && type === "VIET") {
            navigate('/startexamviet');
        }
        else if (type && type === "NGUPHAP") {
            navigate('/startexamgrammar');
        }
        else {
            navigate('/startexam');
        }
    }

    return (
        <>
            <Dialog
                header="Yêu cầu chế độ toàn màn hình"
                visible={showForceFullscreen}
                closable={false}
                draggable={false}
                resizable={false}
                modal
                style={{ width: 'min(560px, 95vw)' }}
                footer={
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, paddingTop: 4 }}>
                        <Button
                            label="Bật lại toàn màn hình"
                            icon="pi pi-window-maximize"
                            className="p-button"
                            style={{
                                background: '#23085a',
                                borderColor: '#23085a',
                                boxShadow: '0 10px 18px rgba(35, 8, 90, 0.22)'
                            }}
                            onClick={async () => {
                                const ok = await requestFullScreen();
                                setShowForceFullscreen(!ok);
                            }}
                        />
                    </div>
                }
            >
                <div style={{ display: 'flex', gap: 14, lineHeight: 1.5, padding: '6px 2px 2px 2px' }}>
                    <div
                        style={{
                            width: 44,
                            height: 44,
                            borderRadius: 12,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: 'rgba(35, 8, 90, 0.08)',
                            color: '#23085a',
                            flex: '0 0 auto'
                        }}
                    >
                        <i className="pi pi-window-maximize" style={{ fontSize: 18 }} />
                    </div>
                    <div style={{ flex: 1 }}>
                        <div style={{ fontSize: 16, fontWeight: 700, color: '#111827', marginBottom: 6 }}>
                            Vui lòng bật chế độ toàn màn hình để tiếp tục
                        </div>
                        <div style={{ fontSize: 14, color: '#4b5563' }}>
                            Bạn đang thoát khỏi toàn màn hình. Bấm <b>Bật lại toàn màn hình</b> để quay lại và tiếp tục xem phần giới thiệu.
                        </div>
                        <div style={{ marginTop: 10, fontSize: 12, color: '#6b7280' }}>
                            Mẹo: Nếu trình duyệt chặn, hãy thử bấm lại nút một lần nữa.
                        </div>
                    </div>
                </div>
            </Dialog>
            {loading
                ? <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '80vh',
                    flexDirection: 'column',
                    textAlign: 'center'
                }}>
                    <ProgressSpinner />
                </div>
                :
                <div className="container">
                    <div className='div1'>
                        <h2 className="title">
                            Aptis General
                            <span> {renderTitle(type)}  </span>
                            Instructions
                        </h2>
                        <p><strong>{renderTitle(type)}</strong></p>
                        <div dangerouslySetInnerHTML={{ __html: dataDetail.des }}></div>
                    </div>

                </div>

            }


            <div className='divfooter d-flex justify-content-between'>
                <div className="menu-container align-items-center d-inline-flex">
                    <button className="btn1"
                        onClick={() => openDetailMenu()}
                    >
                        <span className="mat-button-wrapper">
                            <IoMdMenu size={24} />
                        </span>
                    </button>
                    <button className="btn1"
                        onClick={() => setVisibleInFo(true)}>
                        <span className="mat-button-wrapper">
                            <IoIosInformationCircleOutline size={24} />
                        </span>
                    </button>
                    {/* <button className="btn1"
                        onClick={() => openDetailMenu()}>
                        <span className="mat-button-wrapper">
                            <MdSettingsAccessibility size={24} />
                        </span>
                    </button> */}
                </div>
                <div className="nav-container ml-auto align-items-center d-inline-flex">
                    <button className="btn1"
                    // onClick={() => confirmExit()}
                    >
                        <span className="mat-button-wrapper">
                            <IoMdExit size={24} />
                        </span>
                    </button>
                    <button onClick={() => openStart()} mat-flat-button="" color="primary" className="btn2 ">
                        <a className="d-flex justify-content-center align-items-center">
                            <span className="mr-2 text-white">Next</span>
                            <FaArrowRight className="text-white" size={20} />
                        </a>
                    </button>
                </div>
            </div>


            <Navmenudetail
                visible={visible}
                onClose={onCloseDetailMenu}
                type={type}
                socauhoi={socauhoi}
                arrIdQuestion={[]}
            >
            </Navmenudetail>

            <NavInfo
                visible={visibleInFo}
                type={type}
                onClose={() => setVisibleInFo(false)}
            ></NavInfo>

            <ConfirmDialog />
            <Toast ref={toast} />
        </>
    )
}

export default ExamDetail;
